module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Carrot-5229d5ef2eb400ac40ac90e639b25520253e7a8064f15a70e1c35303ca66d46b.svg";